import { OPEN_DASHBOARD } from '@interhyp/api-dashboard';
import { OPEN_INTENT } from '@interhyp/api-intent-data';
import { IntentFact } from '@interhyp/shared-interim-portal';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useIsCustomer } from '../../../hooks/useIsCustomer';
import { intentsGetList } from '../../../redux/Intents/selectors';
import { useMyIntents } from '../requests/useMineIntents';

export const useIntentToggle = (): {
  intents: IntentFact[];
  onSelect: ({ key }: { key: string }) => void;
} => {
  const intents = useSelector(intentsGetList);

  const isCustomer = useIsCustomer();

  const richIntents = useMyIntents(intents.length);

  const relevantRichIntents = useMemo(() => {
    return (
      richIntents?.filter(richIntent =>
        intents.some(intent => intent.intentId === richIntent.intentId),
      ) ?? []
    );
  }, [intents, richIntents]);

  const onSelect = useCallback(
    ({ key }: { key: string }) => {
      if (isCustomer) {
        OPEN_DASHBOARD.emit({
          id: key,
        });
      } else {
        OPEN_INTENT.emit({
          id: key,
        });
      }
    },
    [isCustomer],
  );

  return { intents: relevantRichIntents, onSelect };
};
